export function detailFormatToSample(json, v5) {
  if (json.values && json.values.tagValues) {
    const tagValues = json.values.tagValues;
    let newTagValues = {};
    let tagCounts = {};

    for (let item in tagValues) {
      newTagValues[item] = {};
      tagCounts[item] = 0;
      // 第一層property
      if(tagValues.hasOwnProperty(item)) { // exclude the property by inherit
        // 第二層property
        for (let subItem in tagValues[item]) {
          // api format change
          // TODO:  for dev
          if (v5) {
            if (subItem==='@values') {
              for (let thirdItem in tagValues[item][subItem]) {
                newTagValues[item][thirdItem] = tagValues[item][subItem][thirdItem];
                tagCounts[item] += tagValues[item][subItem][thirdItem];
              }
            }
          } else {
            newTagValues[item][subItem] = tagValues[item][subItem].values;
            tagCounts[item] += tagValues[item][subItem].values;
          }
        }
      }
    }

    const results = {
      values: {
        action: 'v5api',
        response: json.response_status,
        tagCounts: tagCounts,
        tagValues: newTagValues
      }
    }
    return results;
  }
  else {
    return {
      values: {
        action: 'no-data',
        response: 'no-data',
        tagCounts: {},
        tagValues: {}
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/dataTransfer.js